import { Axios } from "@/utils/axios";

export type LeadType = "checklist" | "home";
export type LeadUrgencyStatus = "여유" | "1달" | "임박" | "임종상태";

export interface PostLeadV2Body {
  phone: string;
  lead_type: LeadType;
  slack_message: string;
  status?: LeadUrgencyStatus;
  accept_night_call?: boolean;
  /** true면 홈질문 야간 장컴에서 임박도만 건너뜀. 장컴 시간은 BE 판정. */
  is_force_outsourcing_night_call?: boolean;
}

export const postLeadV2 = async (body: PostLeadV2Body) => {
  const { data } = await Axios.post("/v2/leads/", body);
  return data;
};

/** 임박도 3지선다 라디오 문구. 모달들이 같이 쓰고, 선택값은 checklistLeadStatus 로 status 에 매핑한다. */
export const CHECKLIST_STATUS_OPTIONS = [
  "미리 준비하려고 해요",
  "임종이 임박하신 상태입니다.",
  "임종하신 상태입니다.",
];

/** 체크리스트 3지선다(미리 준비/임박/임종) 문구 → v2 status enum. */
export const checklistLeadStatus = (
  label: string
): LeadUrgencyStatus | undefined => {
  switch (label) {
    case "임종하신 상태입니다.":
      return "임종상태";
    case "임종이 임박하신 상태입니다.":
      return "임박";
    case "미리 준비하려고 해요":
      return "여유";
    default:
      return label.includes("임종") ? "임종상태" : undefined;
  }
};
